/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * BVHI Product Data Platform
 * The backend service api is responsible for managing users, customer data, product catalogs, and api token.
 * OpenAPI spec version: 1.28.12
 */

/**
 * The criteria for the ccess matching rule.
 */
export type PlatformCatalogAccessMatchingRuleCriteria =
  (typeof PlatformCatalogAccessMatchingRuleCriteria)[keyof typeof PlatformCatalogAccessMatchingRuleCriteria];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlatformCatalogAccessMatchingRuleCriteria = {
  EQUALS: "EQUALS",
  NOT_EQUALS: "NOT_EQUALS",
  LOWER: "LOWER",
  HIGHER: "HIGHER",
  LOWER_OR_EQUALS: "LOWER_OR_EQUALS",
  HIGHER_OR_EQUALS: "HIGHER_OR_EQUALS",
} as const;
